/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { getRequest, patchRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const UpdateStory = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({
        startupName: '',
        founderName: '',
        caseStudy: '',
        interview: '',
        videoUrl: '',
        growthMetrics: '',
        is_active: true,
        image: null
    });
    const [existingImage, setExistingImage] = useState('');
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStoryDetails = async () => {
            try {
                const res = await getRequest(`success-stories/${id}?all=true`);
                const data = res?.data;
                if (data) {
                    setFormData({
                        startupName: data.startupName || '',
                        founderName: data.founderName || '',
                        caseStudy: data.caseStudy || '',
                        interview: data.interview || '',
                        videoUrl: data.videoUrl || '',
                        growthMetrics: data.growthMetrics || '',
                        is_active: data.is_active,
                        image: null
                    });
                    setExistingImage(data.image);
                }
            } catch (err) {
                console.error(err);
                toast.error("Failed to load success story details.");
            } finally {
                setFetching(false);
            }
        };

        fetchStoryDetails();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value === 'true'
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const data = new FormData();
        data.append('startupName', formData.startupName);
        data.append('founderName', formData.founderName);
        data.append('caseStudy', formData.caseStudy);
        data.append('interview', formData.interview);
        data.append('videoUrl', formData.videoUrl);
        data.append('growthMetrics', formData.growthMetrics);
        data.append('is_active', formData.is_active);
        
        if (formData.image) {
            data.append('image', formData.image);
        }

        try {
            await patchRequest(`success-stories/${id}`, data);
            toast.success('Success story updated successfully!');
            navigate('/stories');
        } catch (error) {
            console.error('Failed to update success story:', error);
            toast.error(error?.message || 'Error occurred while updating success story.');
        } finally {
            setLoading(false);
        }
    };

    if (fetching) {
        return (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className='container-fluid mt-5 mb-5'>
                <div className='mainheadig mx-4 mb-4'>
                    <h4 className='text-white font-weight-bold'>Update Success Story</h4>
                </div>
                <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                    <div className='row'>
                        <div className='col-sm-6 form-group'>
                            <label className='admin-label font-weight-bold'>Startup Name *</label>
                            <input
                                type='text'
                                name='startupName'
                                className='form-control'
                                value={formData.startupName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className='col-sm-6 form-group'>
                            <label className='admin-label font-weight-bold'>Founder Name(s) *</label>
                            <input
                                type='text'
                                name='founderName'
                                className='form-control'
                                value={formData.founderName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Growth Metrics</label>
                            <textarea
                                name='growthMetrics'
                                className='form-control'
                                rows="3"
                                value={formData.growthMetrics}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Case Study (Safalta ki Kahaani)</label>
                            <textarea
                                name='caseStudy'
                                className='form-control'
                                rows="5"
                                value={formData.caseStudy}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Founder Interview / Q&A</label>
                            <textarea
                                name='interview'
                                className='form-control'
                                rows="4"
                                value={formData.interview}
                                onChange={handleChange}
                            ></textarea>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>YouTube Video Link</label>
                            <input
                                type='url'
                                name='videoUrl'
                                className='form-control'
                                value={formData.videoUrl}
                                onChange={handleChange}
                            />
                        </div>

                        <div className='col-sm-6 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Status</label>
                            <select
                                name="is_active"
                                className="form-control"
                                value={formData.is_active ? "true" : "false"}
                                onChange={handleSelectChange}
                            >
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        </div>

                        <div className='col-sm-12 form-group mt-3'>
                            <label className='admin-label font-weight-bold'>Replace Image</label>
                            <input
                                type='file'
                                name='image'
                                className='form-control filebg'
                                onChange={handleChange}
                                accept="image/*"
                            />
                            {existingImage && !formData.image && (
                                <div className="mt-2">
                                    <small className="text-muted d-block">Current Image:</small>
                                    <img
                                        src={`${process.env.REACT_APP_BACKEND}uploads/${existingImage}`}
                                        alt="existing"
                                        width={100}
                                        style={{ borderRadius: '4px', marginTop: '5px' }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    
                    <div className='mt-4 text-right'>
                        <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={() => navigate('/stories')}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className='btn addbtn pl-4 pr-4'
                            disabled={loading}
                        >
                            {loading ? 'Updating...' : 'Update Success Story'}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
};

export default UpdateStory;
